require('./_wks-define')('observable');


//////////////////
// WEBPACK FOOTER
// /var/www/umem/~/core-js/modules/es7.symbol.observable.js
// module id = 259
// module chunks = 0